<!-- case refunded -->
<div class="max-tablet:block flex gap-3 rounded-lg"
>
	<div class="flex-col w-full">
		<div
			class="flex flex-col text-dark-grey bg-off-white px-6 pb-3 rounded-lg mb-3"
		>
			<div class="border-b-2 pt-5 flex justify-between items-center">
				<p
					class="text-font-18 mt-3 text-dark-gray ltr:font-DIN-Bold font-bold rtl:font-medium"
				>
					{{ 'ORDERRETURN.RETURNS_DETAILS.RETURN_INFO' | translate }}
				</p>

				<app-status
					[enumData]="ReturnStatus"
					[statusValue]="returnData?.orderReturn?.status"
				></app-status>
			</div>
			<div class="pt-4 flex">
				<p class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.REQUEST_NO' | translate }}
				</p>
				<p class="w-[50%]">#{{ returnData?.orderReturn?.serialNumber }}</p>
			</div>

			<div class="flex">
				<p class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.Order_NO' | translate }}
				</p>
				<p
					[routerLink]="
						'../../../store/orders/order-details/' + returnData?.order?.id
					"
					class="text-[#007AFF] text-font-12 w-[50%] cursor-pointer"
				>
					#{{ returnData?.order?.serialNumber}}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.REQUEST_DATE' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ returnData?.orderReturn?.requestDate | date : 'dd / MM / yyy' }}
					{{ returnData?.orderReturn?.requestDate | date : 'h:mm a' : 'UTC' }}
				</p>
			</div>
			<div *ngIf="returnData?.orderReturn?.status!= 1" class="flex">
				<p class="w-[50%]">
					{{
						(returnData?.orderReturn?.status == 2
							? 'ORDERRETURN.RETURNS_DETAILS.REFUND_DATE'
							: 'ORDERRETURN.RETURNS_DETAILS.REJECTED_DATE'
						) | translate
					}}
					
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ returnData?.orderReturn?.actionDate | date : 'dd / MM / yyy' }}
					{{ returnData?.orderReturn?.actionDate | date : 'h:mm a' : 'UTC' }}
				</p>
			</div>
			



			<div class="custom-table overflow-x-auto">
				<table class="mat-elevation-z8 bg-transparent w-full relative">
					<thead class="bg-light">
						<tr class="border-b-[1px] border-secondry-color-Gray">
							<td
								class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap">
								{{ 'ORDERRETURN.RETURNS_DETAILS.PRODUCT_NAME' | translate }}
							</td>
			
							<td
								class="text-font-14 leading-[22px] text-medium-gray py-[14px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center">
								{{ 'ORDERRETURN.RETURNS_DETAILS.QUANTITY' | translate }}
							</td>
							<td
								class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center">
								<!-- {{ 'STORE.ADD_PRODUCT.STOCK' | translate }} -->
								{{ 'ORDERRETURN.RETURNS_DETAILS.RETURNED_QUANTITY' | translate }}
							</td>
							<td
								class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center">
								{{ 'ORDERRETURN.RETURNS_DETAILS.PRICE' | translate }}
							</td>
							<td
								class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center">
								{{ 'ORDERRETURN.RETURNS_DETAILS.REASON' | translate }}
							</td>
							<td></td>
						</tr>
					</thead>
					<tbody class="bg-grey-background">
						<ng-container *ngFor="let product of returnData?.orderReturnProduct; let i = index">
							<tr>
								
								<td
									class="text-center text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-wrap">
									
									{{
										this.translate.currentLang === 'ar'
											? product?.productName?.ar
											: product?.productName?.en
									}}
								</td>
								<td
									class="text-center text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap">
									
									{{
										 product?.quantity
									}}
								</td>
								<td
									class="text-center text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap">
									
									{{
										 product?.returnedQuantity
									}}
								</td>
								<td
									class="text-center text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] max-mobile:px-padding-mobile-14 whitespace-nowrap font-Poppins-regular ltr:pl-[35px] rtl:pr-[22px]">
									<h1 class="text-font-16 text-dark-grey max-mobile:text-font-12 m-0">
										
										{{ product?.price }}
										{{
											this.translate.currentLang == 'ar'
												? returnData?.currency?.name?.ar
												: returnData?.currency?.name?.en
										}}
									</h1>
								</td>
								<td
									class="text-center text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-wrap">
									
									{{
										this.translate.currentLang == 'ar'
											? product?.reason?.ar
											: product?.reason?.en
									}}
									{{
										 product?.otherReason
											
									}}
								</td>
								
							</tr>
						</ng-container>
					</tbody>
				</table>
			</div>


		
		</div>
	</div>
	<div class="flex-col w-full">
		<div
			class="flex flex-col text-dark-grey bg-off-white px-6 pb-3 rounded-lg mb-3"
		>
			<div class="border-b-2 pt-5 flex justify-between items-center">
				<p
					class="text-font-18 mt-3 text-dark-gray ltr:font-DIN-Bold font-bold rtl:font-medium"
				>
					{{ 'ORDERRETURN.RETURNS_DETAILS.Order_INFO' | translate }}
				</p>

			</div>
			
			<div class="flex">
				<p class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.Order_NO' | translate }}
				</p>
				<p
					[routerLink]="
						'../../../store/orders/order-details/' + returnData?.order?.id
					"
					class="text-[#007AFF] text-font-12 w-[50%] cursor-pointer"
				>
					#{{ returnData?.order?.serialNumber}}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.ORDER_DATE' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ returnData?.order?.orderDate | date : 'dd / MM / yyy' }}
					{{ returnData?.order?.orderDate | date : 'h:mm a' : 'UTC' }}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.TOTAL_AMOUNT' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ returnData?.order?.orderTotalAmount}}
					
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.TOTAL_QUANTITY' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ returnData?.order?.orderTotalQuantity}}
					
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.ORDER_PRODUCT_NUMBER' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ returnData?.order?.orderProductNumber}}
					
				</p>
			</div>



			


		<!--	<div class="flex">
				<p class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.REQUEST_REASON' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.requestReason }}
				</p>
		 	</div>
			<div class="flex">
				<p class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.REFUND_DETAILS.REQUEST_AMOUNT' | translate }}
				</p>
				<p
					class=" text-font-12 w-[50%] {{
						refundData?.refundStatus == 3
							? 'text-[#B3261E]'
							: 'text-medium-gray'
					}}"
				>
					{{ refundData?.requestAmount }}
					{{
						translate.currentLang == 'ar'
							? refundData?.currency?.name?.ar
							: refundData?.currency?.name?.en
					}}
				</p>
			</div>
			<div *ngIf="refundData?.refundStatus == 2" class="flex">
				<p class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.REFUND_DETAILS.REFUND_AMOUNT' | translate }}
				</p>
				<p class="text-[#00BA88] text-font-12 w-[50%]">
					{{ refundData?.requestAmount }}
					{{
						translate.currentLang == 'ar'
							? refundData?.currency?.name?.ar
							: refundData?.currency?.name?.en
					}}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.REFUND_DETAILS.BOOKING_AMOUNT' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.bookingAmount }}
					{{
						translate.currentLang == 'ar'
							? refundData?.currency?.name?.ar
							: refundData?.currency?.name?.en
					}}
				</p>
			</div>
			<div class="flex">
				<p *ngIf="refundData?.refundStatus == 2" class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.REFUND_BY' | translate }}
				</p>
				<p *ngIf="refundData?.refundStatus == 3" class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.REJ_BY' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.actionUserName }}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">
					{{
						refundData?.refundStatus == 2
							? ('ORDERRETURN.RETURNS_DETAILS.ACC_REASON' | translate)
							: refundData?.refundStatus == 3
							? ('ORDERRETURN.RETURNS_DETAILS.REJ_REASON' | translate)
							: ''
					}}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.refundActionReason }}
				</p>
			</div> -->
		</div>
	</div>
	
</div>


<div class="max-tablet:block flex gap-3 rounded-lg">
	<div class="flex-col w-full">
		<div
			class="flex flex-col text-dark-grey bg-off-white px-6 pb-3 rounded-lg mb-3 min-h-[200px]"
		>
			<div class="border-b-2 pt-5 flex justify-between">
				<p
					class="text-font-18 mt-5 text-dark-gray ltr:font-DIN-Bold font-bold rtl:font-medium"
				>
					{{ 'ORDERRETURN.RETURNS_DETAILS.CLIENT_INFO' | translate }}
				</p>
				<button
					[routerLink]="
						'../../../clients/client-profile/' + returnData?.client?.id
					"
					class="border border-solid border-secondry-color-Gray text-dark-grey hover:bg-gradient hover:text-off-white rounded-lg max-mobile:text-[8px]"
					mat-button
				>
					{{ 'ORDERRETURN.RETURNS_DETAILS.VIEW_PROFILE' | translate }}
				</button>
			</div>
			<div class="pt-4 flex">
				<p class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.CLIENT_NAME' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ returnData?.client?.name }}
				</p>
			</div>

			<div class="flex">
				<p class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.PHONE' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ returnData?.client?.mobileNumber }}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">{{ 'ORDERRETURN.RETURNS_DETAILS.EMAIL' | translate }}</p>
				<div class="flex flex-col leading-3">
					<p class="text-medium-gray text-font-12">
						{{ returnData?.client?.emailAddress }}
					</p>
				</div>
			</div>
			<div class="flex">
				<p class="w-[50%]">{{ 'ORDERRETURN.RETURNS_DETAILS.CITY_AREA' | translate }}</p>
				<div class="flex flex-col leading-3">
					<p class="text-medium-gray text-font-12">
						{{
							this.translate.currentLang === 'ar'
								? returnData?.orderReturn?.city?.ar
								: returnData?.orderReturn?.city?.en
						}} &
						{{
							this.translate.currentLang === 'ar'
								? returnData?.orderReturn?.area?.ar
								: returnData?.orderReturn?.area?.en
						}}
					</p>
				</div>
			</div>
			<div class="flex">
				<p class="w-[50%]">{{ 'ORDERRETURN.RETURNS_DETAILS.ADDRESS' | translate }}</p>
				<div class="flex flex-col leading-3">
					<p class="text-medium-gray text-font-12">
						{{ returnData?.orderReturn?.address }}
					</p>
				</div>
			</div>
	</div>

		
	</div> 

	<div class="flex-col w-full">
		<div
			class="flex flex-col text-dark-grey bg-off-white px-6 pb-3 rounded-lg mb-3 min-h-[200px]"
		>
			<div class="border-b-2 pt-5 flex justify-between">
				<p
					class="text-font-18 mt-5 text-dark-gray ltr:font-DIN-Bold font-bold rtl:font-medium"
				>
					{{ 'ORDERRETURN.RETURNS_DETAILS.PAYMENT_INFO' | translate }}
				</p>
				
			</div>
			<div class="pt-4 flex">
				<p class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.TOTAL_AMOUNT' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ returnData?.orderReturnPayment?.totalOrderAmount }}
					{{
						this.translate.currentLang == 'ar'
							? returnData?.currency?.name?.ar
							: returnData?.currency?.name?.en
					}}
				</p>
			</div>
			<div class="pt-4 flex">
				<p class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.TOTAL_RETURNED_AMOUNT' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ returnData?.orderReturnPayment?.totalReturnedAmount }}
					{{
						this.translate.currentLang == 'ar'
							? returnData?.currency?.name?.ar
							: returnData?.currency?.name?.en
					}}
				</p>
			</div>
			<div class="pt-4 flex">
				<p class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.TOTAL_RETURNED_POINTS' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ returnData?.orderReturnPayment?.totalPointsReturned }}
					
				</p>
			</div>
			<div *ngIf="returnData?.orderReturn?.status!=1" class="pt-4 flex">
				<p class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.NOTES' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ returnData?.notes }}
					
				</p>
			</div>
			<div *ngIf="returnData?.orderReturn?.status!=1" class="pt-4 flex">
				<p class="w-[50%]">
					{{ 'ORDERRETURN.RETURNS_DETAILS.EXTRA_FEES' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ returnData?.extraFees }}
					
				</p>
			</div>
			<div *ngIf="returnData?.orderReturn?.status == 1">
				<mat-form-field appearance="outline" class="w-full relative my-[12px]">
					<mat-label class="text-dark-grey">{{
						'ORDERRETURN.RETURNS_DETAILS.EXTRA_FEES' | translate
					}}</mat-label>
					<input
						name="extraFeesInput"
						(wheel)="$event.preventDefault()"
								(keypress)="
									keypressValidation(
										$event,
										null
									)
								"
						class="text-font-16 text-[#4E4B66]"
						formControlName="extraFees"
						matInput
						maxlength="4"
						placeholder="{{'ORDERRETURN.RETURNS_DETAILS.EXTRA_FEES' | translate }}"
						(change)="inputChange($event)"
						type="number"
					/>
					<!-- HTML -->

					<img
						(click)="getController('extraFees')?.reset()"
						*ngIf="
							getController('extraFees')?.value 
						"
						alt=""
						class="cursor-pointer absolute ltr:right-0 rtl:left-0 inline-block top-[9px]"
						src="./assets/images/close-square.svg"
					/>
					<mat-error>
						<validation-message
							[controller]="getController('extraFees')"
							controller_name="ORDERRETURN.RETURNS_DETAILS.EXTRA_FEES"
							pattern_Message="VALIDATION.NUMBER"
						>
						</validation-message>
					</mat-error>
					<mat-error *ngIf="extraFees < 0">
						{{ 'VALIDATION.MIN_NO' | translate : { number: 0 } }}
					</mat-error>
				</mat-form-field>
				<mat-form-field appearance="outline" class="w-full relative mb-[12px]">
					<mat-label class="text-dark-grey">{{
						'ORDERRETURN.RETURNS_DETAILS.NOTES' | translate
					}}</mat-label>
					<input
						class="text-font-16 text-[#4E4B66]"
						name="notesInput"
						formControlName="notes"
						matInput
						placeholder="{{ 'ORDERRETURN.RETURNS_DETAILS.NOTES' | translate }}"
						(change)="inputChange($event)"
						type="text"
					/>
					<img
						(click)="getController('notes')?.reset()"
						*ngIf="getController('notes')?.value"
						alt=""
						class="cursor-pointer absolute ltr:right-0 rtl:left-0 inline-block top-[9px]"
						src="./assets/images/close-square.svg"
					/>
					<mat-error>
						<validation-message
							[controller]="getController('notes')"
							controller_name="ORDERRETURN.RETURNS_DETAILS.EXREA_FEES"
							pattern_Message="VALIDATION.NAME"
						>
						</validation-message>
					</mat-error>
				</mat-form-field>
				<button
					(click)="acceptOrderReturn()"
					type="submit"
					class="bg-gradient text-font-14 text-off-white rounded-[5px] w-full py-8px mb-2"
					mat-button
				>
					{{ 'ACTIONS.ACCEPT' | translate }}
				</button>
				<button
					(click)="rejectOrderReturn()"
					type="submit"
					class="bg-transparent text-font-14 border-solid border-[1px] secondry-color-Gray rounded-[5px] w-full py-8px mb-[8px]"
				>
					{{ 'ACTIONS.REJECT' | translate }}
				</button>
			</div>
			
	</div>

	
	</div> 
</div>

